// Taxe globale cachée (couvre les frais de gateway de paiement) — PM Spec 06/2026
// Appliquée sur le PRIX UNITAIRE de chaque ligne, arrondi au 100 FCFA le plus proche.
// Totalement invisible au client (aucune ligne de taxe séparée) : elle est incorporée
// dans les prix unitaires. La facture et la FNE reprennent naturellement ces prix.
export const HIDDEN_TAX_RATE = 2; // %

export const roundTo100 = (v) => Math.round((Number(v) || 0) / 100) * 100;

export const taxedUnitPrice = (base, rate = HIDDEN_TAX_RATE) =>
  roundTo100((Number(base) || 0) * (1 + rate / 100));

// Transforme les lignes en incorporant la taxe cachée sur le prix unitaire.
// `prix_unitaire_base_ht` conserve le prix de base réel (idempotence à l'édition).
// Retourne { items, meta } — meta sert au reporting/marge interne.
export function applyHiddenTaxToItems(items, apply, rate = HIDDEN_TAX_RATE) {
  let baseTotal = 0;
  let taxedTotal = 0;
  const out = (items || []).map((it) => {
    const qte = Number(it.quantite ?? it.quantity ?? 0) || 0;
    // Le prix de base réel = prix_unitaire_base_ht si déjà présent, sinon la saisie courante
    const base = Number(it.prix_unitaire_base_ht ?? it.prix_unitaire_ht ?? it.unitPrice ?? 0) || 0;
    if (!apply) {
      baseTotal += qte * base;
      taxedTotal += qte * base;
      const { prix_unitaire_base_ht, ...rest } = it;
      return { ...rest, prix_unitaire_ht: base, montant_total_ht: qte * base };
    }
    const taxedPu = taxedUnitPrice(base, rate);
    baseTotal += qte * base;
    taxedTotal += qte * taxedPu;
    return {
      ...it,
      prix_unitaire_base_ht: base,
      prix_unitaire_ht: taxedPu,
      montant_total_ht: qte * taxedPu,
    };
  });
  const meta = apply
    ? {
        applied: true,
        rate,
        baseTotalHT: Math.round(baseTotal),
        taxTotal: Math.round(taxedTotal - baseTotal),
        taxedTotalHT: Math.round(taxedTotal),
      }
    : { applied: false, rate };
  return { items: out, meta };
}
